import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

const FormRow = ({children, className, label, required, style, width}) => {
  const displayLabel = label ? `${label}:` : '';

  return (
    <Grid.Row className={className} style={style}>
      {width.first === 0 ? null : (
        <Grid.Column
          textAlign="right"
          verticalAlign="middle"
          width={width.first}
        >
          <div className={`${required ? 'mhd--required' : ''}`}>
            {displayLabel}
          </div>
        </Grid.Column>
      )}

      <Grid.Column computer={width.second} tablet={12}>
        {children}
      </Grid.Column>
    </Grid.Row>
  );
};

FormRow.defaultProps = {
  className: '',
  label: null,
  required: false,
  style: null,
  width: {
    first: 4,
    second: 6,
  },
};

FormRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  style: PropTypes.shape({}),
  width: PropTypes.shape({
    first: PropTypes.number.isRequired,
    second: PropTypes.number.isRequired,
  }),
};

export default FormRow;



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormRow.js